const PriceRibbon = () => (
  <div className="bg-ivory border-b border-line" data-testid="price-ribbon">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row md:items-baseline gap-2 md:gap-10">
      <span className="text-[10px] tracking-[0.25em] uppercase font-semibold text-teal shrink-0">Published starting prices</span>
      <span className="font-serif text-lg md:text-xl font-light text-charcoal" data-testid="price-ribbon-prices">
        1-Bedroom from $890,000 &middot; 2-Bedroom from $1,250,000 &middot; 3-Bedroom from $2,701,000
      </span>
      <span className="text-[10px] text-stone2 italic shrink-0">Approximate; subject to change.</span>
    </div>
  </div>
);

export default PriceRibbon;
